export const SortOrder = {
    NameAsc: 'NameAsc',
    NameDesc: 'NameDesc', 
    DateDesc: 'DateDesc', 
    DateAsc: 'DateAsc'
};